import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { BcmApiService } from './bcm-api.service';

export type BcmPermissionType = 'read' | 'write' | 'delete' | 'special';

export interface BcmPermission {
    id: number;
    permission: string;
    title: string;
    note: string | null;
    permission_type: BcmPermissionType;
}

export interface ActiveUserPermissionsResult {
    permissions: string[];
    role: {
        visibleName: string;
        uniqueName: string;
    };
}

@Injectable({
    providedIn: 'root'
})
export class BcmPermissionsApiService extends BcmApiService {

    private RESOURCE_ENDPOINT = 'permissions';

    getAll(params: HttpParams = new HttpParams()): Observable<BcmPermission[]> {
        return super.get<BcmPermission[]>(this.RESOURCE_ENDPOINT, params);
    }

    getAllFromActiveUser(params: HttpParams = new HttpParams()): Observable<ActiveUserPermissionsResult> {
        return super.get<ActiveUserPermissionsResult>(this.RESOURCE_ENDPOINT + '/active-user', params);
    }

    updateNote(id: number, note: string): Observable<BcmPermission> {
        return super.put<BcmPermission>(`${this.RESOURCE_ENDPOINT}/${id}/note`, { note });
    }

}
